import { render, staticRenderFns } from "./LiveStatTable.vue?vue&type=template&id=3f57c301"
import script from "./LiveStatTable.vue?vue&type=script&lang=js"
export * from "./LiveStatTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports